module.exports = __webpack_public_path__ + "img/Dick Gregory with HRC.c9c2b5cf.png";